import { getTreatments } from '@App/services/api/TreatmentsService';
import { Treatment } from '@App/services/api/TreatmentsService/types/Treatment';
import { useEffect, useState } from 'react';

export function useTreatments() {
  const [treatments, setTreatments] = useState<Treatment[]>([]);

  useEffect(() => {
    async function fetchTreatments() {
      const response = await getTreatments();
      // prepare values
      const noIndication = response.find(i => i.id === '0') as Treatment;
      const treatments = response.filter(i => i.id !== '0');
      setTreatments([
        noIndication,
        ...treatments.sort((a, b) => {
          const strA = a.text.toUpperCase();
          const strB = b.text.toUpperCase();
          return strA < strB ? -1 : 1;
        })
      ]);
    }

    treatments.length === 0 && fetchTreatments();
  }, []);
  return treatments;
}
